const PREFER_KEY = 'painelOsPreferGoogleLogin';
const AUTO_TRIED_KEY = 'painelOsGoogleAutoTried';

/** Marca preferência de login Google (após vínculo ou login Google bem-sucedido). */
export function setPreferGoogleLogin() {
  try {
    localStorage.setItem(PREFER_KEY, '1');
  } catch (_) {
    /* ignore */
  }
}

/** Remove preferência (login senha/e-mail ou desvínculo). */
export function clearPreferGoogleLogin() {
  try {
    localStorage.removeItem(PREFER_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function hasPreferGoogleLogin() {
  try {
    return localStorage.getItem(PREFER_KEY) === '1';
  } catch (_) {
    return false;
  }
}

/** Evita loop de redirect na mesma sessão do navegador. */
export function markGoogleAutoTried() {
  try {
    sessionStorage.setItem(AUTO_TRIED_KEY, '1');
  } catch (_) {
    /* ignore */
  }
}

export function wasGoogleAutoTried() {
  try {
    return sessionStorage.getItem(AUTO_TRIED_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function shouldAutoStartGoogleLogin() {
  return hasPreferGoogleLogin() && !wasGoogleAutoTried();
}
